var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 0H21.3333C22.8 0 24 1.18667 24 2.66667V21.3333C24 22.8061 22.8061 24 21.3333 24H2.66667C1.19391 24 0 22.8061 0 21.3333V2.66667C0 1.18667 1.18667 0 2.66667 0ZM14.9333 18.6667H17.6L13.3333 12L17.6 5.33333H14.9333L12 10.4L9.06667 5.33333H6.4L10.6667 12L6.4 18.6667H9.06667L12 13.6L14.9333 18.6667Z",
    fill: "#1CA261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.0e09d901f7c1fb734dc1a18acde25c6b.svg";
export { ForwardRef as ReactComponent };